import { render, staticRenderFns } from "./ActivityDetails.vue?vue&type=template&id=d7063cca&scoped=true&"
import script from "./ActivityDetails.vue?vue&type=script&lang=js&"
export * from "./ActivityDetails.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDetails.vue?vue&type=style&index=0&id=d7063cca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7063cca",
  null
  
)

export default component.exports